import { render } from "./Teacher.vue?vue&type=template&id=8c655c76&scoped=true"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"

import "./Teacher.vue?vue&type=style&index=0&id=8c655c76&lang=scss&scoped=true"
import "./Teacher.vue?vue&type=style&index=1&id=8c655c76&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c655c76"]])

export default __exports__